import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export function NotFoundPage() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 3 }}>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h4">Page not found</Typography>
        <Typography variant="body2" color="text.secondary">
          The page you are looking for does not exist or has been moved.
        </Typography>
        <Button component={RouterLink} to="/dashboard" variant="contained">
          Go to Dashboard
        </Button>
      </Stack>
    </Box>
  );
}
